import { HUBSPOT_CALENDAR } from "@/services/config";
import { useTranslation } from "react-i18next";
import { useSearchParams, Link } from "react-router-dom";

import { HiOutlineLightningBolt } from "react-icons/hi";
import { FaCheck, FaPhone, FaFilePdf, FaInfo } from "react-icons/fa6";
import { TbStack } from "react-icons/tb";
import { useState } from "react";

const Product = () => {
  const [searchParams] = useSearchParams();
  const { t } = useTranslation();
  const [type, setType] = useState("START-UP");
  const [plan, setPlan] = useState("ACCELERATED");
  const pdfUrl =
    type === "START-UP"
      ? "https://app-na1.hubspotdocuments.com/documents/4406866/view/1117675955?accessId=c93610"
      : "https://app-na1.hubspotdocuments.com/documents/4406866/view/1117676317?accessId=1070ef";

  const ACCELERATED = [
    t("product.accelerated.sansrdv"),
    t("product.accelerated.one"),
    t("product.accelerated.two"),
    t("product.accelerated.three"),
    t("product.accelerated.four"),
    t("product.accelerated.five"),
    t("product.accelerated.six"),
  ];

  const CERTIFIED = {
    "START-UP": [
      t("product.certified.one.startup"),
      t("product.certified.two.startup"),
      t("product.certified.three.startup"),
      t("product.certified.four.startup"),
      t("product.certified.five.startup"),
      t("product.certified.six.startup"),
      t("product.certified.seven.startup"),
      t("product.certified.eight.startup"),
      t("product.certified.nine.startup"),
      t("product.certified.ten.startup"),
    ],
    SME: [
      t("product.certified.one.sme"),
      t("product.certified.two.sme"),
      t("product.certified.three.sme"),
      t("product.certified.four.sme"),
      t("product.certified.five.sme"),
      t("product.certified.six.sme"),
      t("product.certified.seven.sme"),
      t("product.certified.eight.sme"),
      t("product.certified.nine.sme"),
      t("product.certified.ten.sme"),
    ],
  };

  return (
    <div className="px-8">
      <div className="flex flex-col items-center justify-center w-full">
        <div>
          <h1 className="text-center text-xl text-black font-semibold">Bienvenue dans l'évaluation de votre entreprise</h1>
        </div>
        <div className="flex items-center justify-center w-full mt-4 gap-4">
          <p className="text-black font-medium text-center">Vous avez déjà réalisé une Valorisation?</p>
          <Link to="/my-service" className="py-2 px-4 rounded-lg text-white text-sm font-medium bg-primary">
            Voir mes services
          </Link>
        </div>
        <div className="py-4 space-y-4">
          <p className="text-black font-semibold text-center">Vous êtes:</p>
          <div className="flex justify-center space-x-8">
            {searchParams.get("type")?.toUpperCase() === "START-UP" ? (
              <div className="space-y-4 w-full">
                <button
                  className={`flex items-center justify-between border border-secondary rounded-lg h-12 px-6 w-full cursor-pointer text-sm ${
                    type === "START-UP" ? "bg-secondary" : ""
                  }`}
                  onClick={() => setType("START-UP")}>
                  <p className="text-sm">Start up</p>
                </button>
              </div>
            ) : (
              <>
                <button
                  className={`border rounded-lg py-2 w-36 cursor-pointer
                ${type === "START-UP" ? "bg-primary text-white" : "border-primary"}`}
                  onClick={() => setType("START-UP")}>
                  <p className="text-sm text-center font-semibold">Start up</p>
                </button>
                <button
                  className={`border rounded-lg py-2 w-36 cursor-pointer
                ${type === "SME" ? "bg-primary text-white" : "border-primary"}`}
                  onClick={() => setType("SME")}>
                  <p className="text-sm text-center font-semibold">TPE / PME</p>
                </button>
              </>
            )}
          </div>
          <div className="w-full space-y-2">
            <div className="w-full mt-1">
              <h1 className="text-black text-center font-semibold">{t("product.title")}</h1>
            </div>
            <div className="p-4 rounded-lg border border-gray-200 transition-all flex flex-col justify-between">
              <div>
                <h3 className="text-lg font-semibold text-center mb-2 text-gray-800">Découvrez notre rapport d'évaluation {type === "START-UP" ? "Start-up" : "TPE / PME"}</h3>
                <p className="text-sm text-gray-600 text-center mb-3 max-w-lg mx-auto">Consultez un aperçu de notre rapport d'évaluation détaillé</p>
              </div>
              <div className="flex flex-col items-center ">
                <button
                  className="flex secondary-button items-center gap-2 bg-white hover:bg-gray-100 text-gray-800 py-3 px-4 rounded-lg border border-gray-200 shadow-sm transition-all hover:shadow-md"
                  onClick={() => window.open(pdfUrl, "_blank")}>
                  <FaFilePdf className="text-primary text-lg" />
                  <span className="font-medium text-sm">Voir un exemple</span>
                </button>
              </div>
            </div>
            <div className="grid grid-cols-2 gap-8">
              <button
                className={`border-2 ${plan === "ACCELERATED" ? "border-primary" : "border-secondary"} shadow-md rounded-lg p-6 text-primary flex flex-col items-center h-full`}
                onClick={() => setPlan("ACCELERATED")}>
                <div className="flex items-center gap-1 mb-2">
                  <HiOutlineLightningBolt className="text-xl text-primary" />
                  <p className="text-lg font-semibold">{t("product.accelerated.time")}</p>
                </div>
                <div className="flex gap-2 items-end text-black">
                  <h2 className="text-3xl font-semibold">{t("product.accelerated.price")}</h2>
                  <p className="font-semibold">{t("product.accelerated.taxes")}</p>
                </div>
                <p className="mt-2 font-semibold uppercase">{t("product.accelerated.title")}</p>
                <p className="font-semibold">{t("product.accelerated.maturity")}</p>

                <div className="mt-4 flex-1">
                  <p className="text-sm font-semibold">{t("product.accelerated.include")}</p>
                  <ul className="flex flex-col gap-3 mt-4 justify-center">
                    {ACCELERATED?.map((item, i) => (
                      <li className="flex gap-2 text-sm" key={i}>
                        <div className="bg-light_blue rounded-full p-1">
                          <FaCheck className="text-xs" />
                        </div>
                        <p>{item}</p>
                      </li>
                    ))}
                  </ul>
                </div>
                <Link to={`/valuation/new/${type.toLowerCase()}/overview?plan=ACCELERATED`} className="primary-button mt-4 px-8">
                  {t("product.select")}
                </Link>
              </button>
              <button
                className={`border-2 ${plan === "CERTIFIED" ? "border-primary" : "border-secondary"} shadow-md rounded-lg p-6 text-primary flex flex-col items-center h-full`}
                onClick={() => setPlan("CERTIFIED")}>
                <div className="flex items-center gap-1 mb-2">
                  <TbStack className="text-xl text-primary" />
                  <p className="text-lg font-semibold">{t("product.certified.popular")}</p>
                </div>
                <div className="flex gap-2 items-end text-black">
                  <h1 className="text-3xl font-semibold">{t("product.certified.price")}</h1>
                  <p className="font-semibold">{t("product.certified.taxes")}</p>
                </div>
                <p className="mt-2 font-semibold uppercase">{t("product.certified.title")}</p>
                <p className="font-semibold">{t("product.certified.maturity")}</p>

                <div className="mt-4">
                  <p className="text-sm font-semibold">{t("product.certified.include")}</p>
                  <ul className="flex flex-col gap-3 mt-4 justify-center">
                    {CERTIFIED[type]?.map((item, i) => (
                      <li className="flex gap-2 text-sm" key={i}>
                        <div className="bg-light_blue rounded-full p-1">
                          <FaCheck className="text-xs" />
                        </div>

                        <p>{item}</p>
                      </li>
                    ))}
                  </ul>
                </div>
                <Link to={`/valuation/new/${type.toLowerCase()}/overview?plan=CERTIFIED`} className="primary-button mt-4 px-8">
                  {t("product.select")}
                </Link>
              </button>
            </div>

            <div className="flex flex-col items-center mt-10 border-t pt-8 w-full max-w-md mx-auto">
              <h2 className="text-lg text-center font-semibold text-gray-800 mb-2">{t("product.bizzdev")}</h2>
              <a
                href={HUBSPOT_CALENDAR}
                target="_blank"
                rel="noopener noreferrer"
                className="primary-button flex items-center gap-2 px-6 py-2.5 transition-all hover:scale-105 hover:shadow-md">
                <FaPhone className="text-sm" />
                <span className="font-medium">{t("product.contact")}</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Product;
